var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconGallery = function SvgIconGallery(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-11b62b9c-1b6a-40b0-97f0-5b97750aca29",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .uuid-962fc7f6-5f13-49f1-bfc8-b4f1c1f146ed{fill:#393939;isolation:isolate;opacity:.6;}.uuid-962fc7f6-5f13-49f1-bfc8-b4f1c1f146ed,.uuid-43f45ac2-b11d-43bb-95bd-cd1171c19750{stroke-width:0px;}.uuid-43f45ac2-b11d-43bb-95bd-cd1171c19750{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-61c2497f-fb67-4d32-a93f-933faf1d8b73"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "uuid-b08c6683-7534-4664-a0dc-739de83dc267",
    className: "uuid-962fc7f6-5f13-49f1-bfc8-b4f1c1f146ed",
    cx: 25,
    cy: 25,
    r: 24.56
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-b3e035e9-7137-4846-9c6e-01c481560660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-69f7d69d-14ac-4af6-a9c8-4341899eec75",
    className: "uuid-43f45ac2-b11d-43bb-95bd-cd1171c19750",
    d: "M20.52,20.52c0,1.48-1.19,2.68-2.67,2.69,0,0-.01,0-.02,0-1.48,0-2.68-1.19-2.69-2.67,0,0,0-.01,0-.02,0-1.48,1.19-2.68,2.67-2.69,0,0,.01,0,.02,0,1.48,0,2.68,1.19,2.69,2.67,0,0,0,.01,0,.02ZM34.86,25.9v6.28H15.14v-2.69l4.48-4.48,2.24,2.24,7.17-7.17,5.83,5.83ZM36.21,16.03H13.79c-.25,0-.44.2-.45.45v17.04c0,.25.2.44.45.45h22.42c.25,0,.44-.2.45-.45v-17.04c0-.25-.2-.44-.45-.45ZM38.45,16.48v17.04c0,1.24-1.01,2.24-2.24,2.24H13.79c-.6,0-1.17-.23-1.58-.66-.43-.41-.67-.99-.66-1.58v-17.04c0-.6.23-1.17.66-1.58.41-.43.99-.67,1.58-.66h22.42c.6,0,1.17.23,1.58.66.43.41.67.99.66,1.58h0Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconGallery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-gallery.6a637316e138095f9a42a51845deec29.svg";